import { IonButton } from '@ionic/react';
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import { NormalText, SmallText, Spacer, StrongText, Title } from '../common';
import Modal from '../modal';
import ScrollableTabs from '../scrollTabs';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import { capitalize, openExternalLink } from '../../lib/utils';
import { ItemDetailsRaw } from '../../screens/itemDetails';
import './index.css';

const { getProductName, getProductDescription, formatPrice } = Basket;

class ModalItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			allergens: [],
		};
		this.scrollableWrapperRef = createRef();
	}

	componentDidUpdate(prevProps) {
		if (this.props.item && this.props.item !== prevProps.item) {
			this.setState({ allergens: [] });
			if (this.props.restaurant) {
				Basket.setRestaurant(this.props.restaurant);
			}
			setTimeout(() => {
				const splitPane = document.querySelector('ion-split-pane');
				if (splitPane) splitPane.classList.add('blur');
			}, 300);
		}
	}

	handleAlergens = (allergens) => this.setState({ allergens });

	closeModal = () => {
		const splitPane = document.querySelector('ion-split-pane');
		if (splitPane) splitPane.classList.remove('blur');
		if (this.props.onClose) this.props.onClose();
	};

	render() {
		const { item, profile, clientProfile, __ } = this.props;
		const { allergens } = this.state;

		if (!item) return null;

		let modalItemImage = item?.itemRichData?.squareImageUrl || '';
		if (modalItemImage && modalItemImage.indexOf('http://') !== -1) {
			modalItemImage = modalItemImage.replace(/http:\/\//g, 'https://');
		}
		const hasNutritionInfo = item?.itemRichData?.calories || item?.itemRichData?.dietaryFlags?.length > 0;

		return (
			<Modal className="item-details-modal" isOpen={!!item} onDidDismiss={this.closeModal}>
				<div className="item-details-wrapper">
					<div ref={this.scrollableWrapperRef} className="item-details scrollable-wrapper">
						{!getConfig().flags.removeMenuImages && (
							<>
								{modalItemImage ? (
									<img
										className="modal-item-details-image"
										style={{ objectFit: 'cover' }}
										alt="modal item"
										src={modalItemImage}
									/>
								) : (
									<img
										className="modal-item-details-image"
										style={{ objectFit: 'contain' }}
										alt="modal item"
										src={Basket.getRestaurant()?.menu_item_placeholder_image ?? clientProfile?.logo_image}
									/>
								)}
							</>
						)}
						<ScrollableTabs
							parent={this.scrollableWrapperRef}
							tabs={[
								{
									title: 'Description',
									content: (
										<>
											<Title>{__(getProductName(item, profile))}</Title>
											{formatPrice(item.productPrice) && (
												<StrongText>{formatPrice(item.productPrice)}</StrongText>
											)}
											{getProductDescription(item, profile) !== '' && (
												<>
													<Spacer size={2} />
													<NormalText
														className="block item-details-card-description"
														dangerouslySetInnerHTML={{
															__html: getConfig().flags.removeHTMLTagsOnProductDescription
																? getProductDescription(item, profile)
																: getProductDescription(item, profile).replace(/(<([^>]+)>)/gi, ''),
														}}
													/>
												</>
											)}
											{allergens.length > 0 && !hasNutritionInfo && (
												<>
													<Spacer size={2} />
													<SmallText className="primary-color">
														{allergens.map((el) => capitalize(el)).join(', ')}
													</SmallText>
												</>
											)}
											{getConfig()?.customExternalLinks?.product && !hasNutritionInfo && (
												<>
													<Spacer size={2} />
													<IonButton
														onClick={() => openExternalLink(getConfig().customExternalLinks.product?.url)}
														color="secondary"
														className="link"
													>
														{__(getConfig().customExternalLinks.product?.title)}
													</IonButton>
													<Spacer />
												</>
											)}
											{getConfig().frenchDisclaimer?.disclaimerImage && !hasNutritionInfo && (
												<div className="disclaimer-wrapper">
													<img className='disclaimer-image' src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
												</div>
											)}
										</>
									),
								},
								{
									...(hasNutritionInfo && {
										title: 'Nutrition & Safety',
										content: (
											<div style={{ display: 'grid', gap: 'var(--spacer-2)' }}>
												{allergens.length > 0 && (
													<div>
														<StrongText>{__('Allergens')}</StrongText>
														<SmallText className="primary-color">
															{allergens.map((el) => capitalize(el)).join(', ')}
														</SmallText>
													</div>
												)}
												{item.itemRichData?.dietaryFlags?.length > 0 && (
													<div>
														<StrongText>{__('Dietary flags')}</StrongText>
														<SmallText className="primary-color">
															{item.itemRichData.dietaryFlags
																.map((el) => capitalize(el.standard_name.toLowerCase().replace(/_/g, ' ')))
																.join(', ')}
														</SmallText>
													</div>
												)}
												{item.itemRichData?.calories && (
													<div>
														<StrongText>{__('Calories')}</StrongText>
														<SmallText className="primary-color">
															{`${item.itemRichData.calories} ${__('kcal')}`}
														</SmallText>
													</div>
												)}
												{getConfig()?.customExternalLinks?.product && (
													<div>
														<IonButton
															onClick={() => openExternalLink(getConfig().customExternalLinks.product?.url)}
															color="secondary"
															className="link"
														>
															{__(getConfig().customExternalLinks.product?.title)}
														</IonButton>
														<Spacer />
													</div>
												)}
												{getConfig().frenchDisclaimer?.disclaimerImage && (
													<div className="disclaimer-wrapper">
														<img className='disclaimer-image' src={getConfig().frenchDisclaimer?.disclaimerImage}></img>
													</div>
												)}
											</div>
										),
									}),
								},
							]}
						/>
					</div>
					<div className="item-modifiers item-details-content">
						<Title style={{ paddingLeft: 'var(--ion-padding-page)' }}>{__('Options')}</Title>
						<ItemDetailsRaw
							handleAlergens={this.handleAlergens}
							item={{ ...item, selectedUpsellRestaurant: this.props.selectedUpsellRestaurant }}
							profile={profile}
							modalOpen={!!item}
							closeModal={this.closeModal}
						/>
					</div>
				</div>
			</Modal>
		);
	}
}

const stateToProps = (state) => ({
	profile: state.profile.profile,
	clientProfile: state.common.clientProfile,
});

export default connect(stateToProps)(withTranslation(ModalItem));
